module.exports = __webpack_public_path__ + "static/media/testimonial-photo.4a5f451a.png";